import axios from "axios";
import Table from "components/DataTable/Table";
import Spinner from "components/Spinner";
import useApiHook from "Hooks/ApiHook";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";
import FindReportAdvanceFormLayout from "./FindReport/FindReportAdvanceFormLayout";

export default function TaxExemptReport() {
  /*   All States
   ********************************************* */
  const [filterBy, setFilterBy] = useState(null);
  const [addressState, setAddressState] = useState(null);
  const [advanceSearchModal, setAdvanceSearchModal] = useState(false);
  const [searchResult, setSearchResult] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  /*   All Functions
   ********************************************* */

  const getTaxExemptReport = async () => {
    if (!addressState) {
      throw new Error("Please enter a state to generate the report.");
    }

    const response = await API.post(
      "/reports/customers/state",
      {
        state: addressState,
      },
      {
        headers: authHeader(),
      }
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message);
    }
  };

  const exportToExcel = () => {
    let _taxReport = searchResult ? searchResult : taxExemptReport;

    if (!_taxReport || _taxReport.length === 0) {
      alert("No data to export");
      return;
    }

    // Create a CSV string
    const headers = [
      "State",
      "Company Name",
      "Contact",
      "Phone",
      "Email",
      "Tax Exempted",
      "Tax Account",
      "File uploaded",
    ];
    let csvContent = headers.join(",") + "\n";

    _taxReport.forEach((item) => {
      const row = [
        item.addressState || "",
        item.addressCompany || "",
        item.accountPayableContact || "",
        item.accountPayablePhone || "",
        item.accountPayableEmail || "",
        item.isTaxExamption ? "Yes" : "No",
        item?.taxrate?.taxAccountName || "",
        item.examptionFile?.length > 0 ? "Yes" : "No",
      ].map((cell) => `"${String(cell).replace(/"/g, '""')}"`);

      csvContent += row.join(",") + "\n";
    });

    // Create a blob and download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `Customer_Report_${new Date().toLocaleDateString()}.csv`
    );
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadFile = (fileKey) => {
    setIsLoading(true);
    axios
      .post(`${process.env.REACT_APP_API_URI}/aws/images`, {
        key: fileKey,
      })
      .then((response) => {
        const url = response.data[0];
        setIsLoading(false);
        const link = document.createElement("a");
        link.href = url;
        // Opens in a new tab (user, 2026-11-02) instead of downloading.
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })

      .catch((error) => {
        console.log("Error downloading file:", error);
      });
  };

  const {
    data: taxExemptReport,
    loading,
    error: reportFetchError,
    refetch: getData,
    resetData,
  } = useApiHook(() => {
    return getTaxExemptReport();
  }, false);

  const handleViewCustomer = (id) => {
    navigate(`/customer/details/${id}`);
  };

  /*   Table functions
   ********************************************* */
  const btn1 = () => (
    <div>
      <div className="d-flex align-items-center justify-content-center gap-2 ms-1">
        <button
          onClick={() => setAdvanceSearchModal(true)}
          type="button"
          className="btn px-2 btn-primary"
        >
          Find
        </button>

        <button
          onClick={exportToExcel}
          type="button"
          className="btn btn-success "
        >
          Export to Excel
        </button>
      </div>
    </div>
  );

  const table_head = [
    { name: "Actions", value: "Actions" },
    { name: "State", value: "addressState" },
    { name: "Customer Name", value: "customerName" },
    { name: "Bill Company", value: "addressCompany" },
    { name: "Contact", value: "accountPayableContact" },
    { name: "Phone", value: "accountPayablePhone" },
    { name: "Email", value: "accountPayableEmail" },
    { name: "Tax Exempted", value: "isTaxExamption" },
    { name: "Tax Account", value: "taxrate.taxAccountName" },
    { name: "File uploaded", value: "examptionFile.length" },
  ];

  const table_body = (item, index) => (
    <tr className="" key={item.id}>
      <td>
        <button
          onClick={() => handleViewCustomer(item.customerId)}
          className="btn btn-sm btn-primary"
        >
          View
        </button>
      </td>
      <td>{item.addressState}</td>
      <td>{item.customerName}</td>
      <td>{item.addressCompany}</td>
      <td>{item.accountPayableContact}</td>
      <td>{item.accountPayablePhone}</td>
      <td>{item.accountPayableEmail}</td>
      <td>{item.isTaxExamption ? "Yes" : "No"}</td>
      <td>{item?.taxrate?.taxAccountName}</td>
      <td>
        {item.examptionFile?.length > 0 && item.examptionFile !== ""
          ? "Yes"
          : "No"}
        {item.examptionFile?.length > 0 && (
          <button
            onClick={() => downloadFile(item.examptionFile)}
            className="btn btn-sm btn-success ms-2"
          >
            <i className="mdi mdi-download"></i>
          </button>
        )}
      </td>
    </tr>
  );

  /*   All UseEffects
   ********************************************* */
  return (
    <div>
      {(loading || isLoading) && <Spinner />}
      {reportFetchError && (
        <div className="alert alert-danger" role="alert">
          <button
            type="button"
            className="btn-close me-2"
            aria-label="Close"
            onClick={() => resetData()}
          ></button>
          {reportFetchError}
        </div>
      )}

      {/*   Table
       ********************************************* */}
      <div
        className="px-2 flex-grow-1 d-flex"
        style={{ minHeight: "20vh", borderRadius: 15 }}
      >
        <div className="horizontal-scrollable d-flex flex-grow-1">
          <Table
            filterBy={filterBy?.value}
            btn1={btn1}
            disableSearch={true}
            table_head={table_head}
            columnSortable={true}
            table_body={table_body}
            table_data={searchResult ? searchResult : taxExemptReport || []}
          />
        </div>
      </div>
      {/*   Advance Customer Search
       ********************************************* */}
      <Modal
        size="lg"
        contentClassName="bg-transparent"
        show={advanceSearchModal}
        onHide={() => setAdvanceSearchModal(false)}
      >
        <Modal.Body
          className="bg-light custom-shadow-sm p-3"
          style={{ borderRadius: 15 }}
        >
          <FindReportAdvanceFormLayout
            showModal={setAdvanceSearchModal}
            setSearchResult={setSearchResult}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}
